import { render, staticRenderFns } from "./VolunteerBlock.vue?vue&type=template&id=a68f2f4a&"
import script from "./VolunteerBlock.vue?vue&type=script&lang=js&"
export * from "./VolunteerBlock.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports